import usePricingStore from 'stores/pricing_store/usePricingStore';

import { handleUnit } from 'lib/utils';

const PriceBreaks = ({ stepId, vatStatus }) => {
  const { productPrice } = usePricingStore();

  if (!productPrice) return null;

  const {
    breaks: { title, data: breakData },
    per_pack: perPack,
    unit,
  } = productPrice[stepId];

  if (breakData.length === 0) return null;

  // take the first item as we only ever have one priceBreak showing
  // if this changes we'll need to redesign how this will look/work anyway
  const {
    per_pack: bPerPack,
    per_price: bPerPrice,
    per_price_inclusive: bPerPriceInc,
  } = breakData[0];

  return (
    <div className="price-breaks">
      <p className="price-breaks__title">{title}</p>

      <div className="price-breaks__content">
        <span className="price-breaks__per-pack">{bPerPack}</span>
        <span className="price-breaks__price">
          {`£${
            vatStatus ? bPerPrice.toFixed(2) : bPerPriceInc.toFixed(2)
          } for ${perPack}${handleUnit(unit)}`}
        </span>
        <span className="price-breaks__vat">
          {vatStatus ? 'Ex VAT' : 'Inc VAT'}
        </span>
      </div>
    </div>
  );
};

export default PriceBreaks;
